(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["booking-section"] && !Shopify.designMode) return;
  try {
    
const url = "https://app.healthagon.ae";
var userId = localStorage.getItem('userId');

const inputPhone1 = document.querySelector("#phone1");
window.intlTelInput(inputPhone1, {
    initialCountry: "ae",
    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.1.0/build/js/utils.js",
});

const inputPhone2 = document.querySelector("#phone2");
window.intlTelInput(inputPhone2, {
    initialCountry: "ae",
    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.1.0/build/js/utils.js",
});

function scrollToSection(sectionId) {
    $('html, body').animate({
        scrollTop: $(sectionId).offset().top
    }, 50);
}

$(document).ready(function() {
  
    var treatmentData = [];
    populateTreatments();

    let today = new Date().toISOString().split('T')[0];
    document.getElementById('date').setAttribute('min', today);

    function populateTreatments() {
        $.getJSON('https://app.healthagon.ae/Home/services', function(data) {
            treatmentData = data;
            var treatmentOptions = $('#treatment-options');
            treatmentOptions.empty();
            var treatments = {};

            data.forEach(function(service) {
                if (!treatments[service.treatment_id]) {
                    treatments[service.treatment_id] = service.treatment_name;
                }
            });

            $.each(treatments, function(id, name) {
                treatmentOptions.append('<label><input type="radio" name="treatment" value="' + id + '"><p class="m-0 booking-main-txt">' + name + '</p></label>');
            });
        });
    }

    function populateDurations(treatmentId) {
        var durationOptions = $('#duration-options');
        durationOptions.empty();
        var durations = [];

        treatmentData.forEach(function(service) {
            if (service.treatment_id == treatmentId && !durations.some(d => d.duration_id === service.duration_id)) {
                durations.push({
                    duration_id: service.duration_id,
                    duration: service.duration
                });
            }
        });

        durations.sort((a, b) => parseInt(a.duration) - parseInt(b.duration));

        durations.forEach(function(duration) {
            var durationNumber = duration.duration.match(/\d+/)[0];
            durationOptions.append('<label><input type="radio" name="duration" value="' + duration.duration_id + '" data-duration="' + durationNumber + '"><p class="m-0 booking-main-txt">' + duration.duration + '</p></label>');
        });
    }

    function populateTherapists(treatmentId, preference) {
        var url = 'https://app.healthagon.ae/Home/therapists?treatmentId=' + treatmentId;

        if (preference === 'female' || preference === 'male') {
            url += '&preferenceGender=' + preference;

            $.getJSON(url, function(data) {
                var therapistSelect = $('#therapist');
                therapistSelect.empty();

                if (typeof data === 'string') {
                    alert('No therapists available for the selected treatment and preference.');
                } else {
                    $.each(data, function(key, val) {
                        therapistSelect.append('<option value="' + val.therapist_id + '">' + val.therapist + '</option>');
                    });
                }
            });
        } else {
            var femaleUrl = url + '&preferenceGender=female';
            var maleUrl = url + '&preferenceGender=male';

            $.when(
                $.getJSON(femaleUrl),
                $.getJSON(maleUrl)
            ).done(function(femaleData, maleData) {
                var therapistSelect = $('#therapist');
                therapistSelect.empty();
                var allTherapists = [];

                if (typeof femaleData[0] !== 'string') {
                    allTherapists = allTherapists.concat(femaleData[0]);
                }

                if (typeof maleData[0] !== 'string') {
                    allTherapists = allTherapists.concat(maleData[0]);
                }

                if (allTherapists.length === 0) {
                    alert('No therapists available for the selected treatment.');
                } else {
                    $.each(allTherapists, function(key, val) {
                        therapistSelect.append('<option value="' + val.therapist_id + '">' + val.therapist + '</option>');
                    });
                }
            });
        }
    }

    function updateAvailableTimeslots(therapistId, selectedDate, durationId) {
        $.ajax({
            url: 'https://app.healthagon.ae/Home/availablTime',
            data: {
                bookingdate: selectedDate,
                therapist: therapistId,
                duration: durationId
            },
            method: 'GET',

            success: function(data) {
                var timeslotSelect = $('#timeslot');
                timeslotSelect.empty();

                if (typeof data === 'string') {
                    data = JSON.parse(data);
                }

                function convertTo12Hour(time24) {
                    var time = time24.split(':');
                    var hours = parseInt(time[0]);
                    var minutes = time[1];
                    var ampm = hours >= 12 ? 'PM' : 'AM';

                    hours = hours % 12;

                    if (hours == 0) {
                        hours = 12;
                    }

                    return hours + ':' + minutes + ' ' + ampm;
                }

                if (Array.isArray(data) && data.length > 0) {
                    $.each(data, function(index, time) {
                        var displayTime = convertTo12Hour(time);

                        timeslotSelect.append(
                            '<option value="' + time + '">' + displayTime + '</option>'
                        );
                    });
                } else {
                    timeslotSelect.append(
                        '<option value="">No available time slots</option>'
                    );
                }
            },

            error: function() {
                var timeslotSelect = $('#timeslot');
                timeslotSelect.empty();

                timeslotSelect.append(
                    '<option value="">No available time slots</option>'
                );
            }
        });
    }

    function populatePackages(treatmentId, durationId) {
        var packagesContainer = $('.packages-container');
        packagesContainer.empty();

        var packages = treatmentData.filter(function(service) {
            return service.treatment_id == treatmentId && service.duration_id == durationId;
        });

        packages.sort((a, b) => parseInt(a.no_of_sessions) - parseInt(b.no_of_sessions));

        packages.forEach(function(service) {
            var discountMatch = service.package_name.match(/\((\d+%) OFF\)/);
            var discountText = discountMatch ? discountMatch[1] + ' off' : '';
            var packageName = service.package_name.replace(/\(\d+% OFF\)/, '').trim();
            packageName = packageName.replace(/(\d+)-(\d+)/g, '$1 - $2');

            var totalAmount = service.no_of_sessions > 1
              ? 'Pay a total amount of ' + service.clinic_price + ' AED for ' + service.no_of_sessions + ' ' + service.treatment_name + ' sessions'
              : 'Experience ' + service.treatment_name + ' in a Professional Environment';

            packagesContainer.append(
                '<div class="booking-options">' +
                '<label class="d-flex" style="gap:10px;width:100%;">' +
                '<input style="align-self:flex-start;margin:15px 8px;" type="radio" name="package" value="' + service.package_id + '" data-nb-of-session="' + service.no_of_sessions + '">' +
                '<div class="flex-1">' +
                '<p class="m-0 booking-main-txt">' + packageName + ' at just <span class="price-booking">' + (service.clinic_price / service.no_of_sessions) + ' AED/appointment</span></p>' +
                '<p class="m-0 booking-sub-txt" style="margin-left:-20px;margin-top: 15px;">' + totalAmount + '</p>' +
                '</div>' +
                (discountText ? '<p class="m-0 sale-booking">' + discountText + '</p>' : '') +
                '</label>' +
                '</div>'
            );
        });
    }

    $('input[name="therapistPreference"]').change(function() {
        var preference = $(this).val();
        var treatmentId = $('input[name="treatment"]:checked').val();
        var durationId = $('input[name="duration"]:checked').val();

        if (treatmentId) {
            populateTherapists(treatmentId, preference);
        }

        if (treatmentId && durationId) {
            populatePackages(treatmentId, durationId);
        }
    });

    $('#treatment-options').on('change', 'input[name="treatment"]', function() {
        var treatmentId = $(this).val();
        populateDurations(treatmentId);

        $('input[name="therapistPreference"]').prop('checked', false);
        $('#therapist').empty();
        $('#timeslot').empty();
    });

    $('#therapist').change(function() {
        var therapistId = $(this).val();
        var selectedDate = $('#date').val();
        var durationId = $('input[name="duration"]:checked').val();

        $('#select-therapist-message').hide();

        if (selectedDate && durationId) {
            updateAvailableTimeslots(therapistId, selectedDate, durationId);
        }
    });

    $('#duration-options').on('change', 'input[name="duration"]', function() {
        var treatmentId = $('input[name="treatment"]:checked').val();
        var durationId = $(this).val();
        var preference = $('input[name="therapistPreference"]:checked').val();
        var selectedDate = $('#date').val();
        var therapistId = $('#therapist').val();

        if (treatmentId) {
            populateTherapists(treatmentId, preference);
        }

        if (treatmentId && durationId) {
            populatePackages(treatmentId, durationId);
        }

        if (therapistId && selectedDate) {
            updateAvailableTimeslots(therapistId, selectedDate, durationId);
        }
    });

    $('#date').change(function() {
        var selectedDate = $(this).val();
        var therapistId = $('#therapist').val();
        var durationId = $('input[name="duration"]:checked').val();

        if (therapistId && durationId) {
            updateAvailableTimeslots(therapistId, selectedDate, durationId);
        }
    });

    function updateBreadcrumb(step) {
        $('.breadcrumb span').each(function() {
            var itemStep = $(this).data('step');

            if (itemStep <= step) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });
    }



    function registerUser(name, gender, mobile_number) {
        return $.ajax({
            url: 'https://app.healthagon.ae/Home/register',
            data: {
                name: name,
                gender: gender,
                mobile_number: mobile_number
            },
            method: 'GET',
            dataType: 'json',
            success: function(response) {
                if (response.user_id) {
                    localStorage.setItem('userId', response.user_id);
                    localStorage.setItem('userName', name);
                    localStorage.setItem('userGender', gender);
                    localStorage.setItem('userMobileNumber', mobile_number);
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.error('Registration error:', textStatus, errorThrown);
            }
        });
    }

    $('#next-button').click(function() {
        var isValid = true;

        $('#treatment-details input, #treatment-details select').each(function() {
            if ($(this).is(':invalid') || !$(this).val()) {
                isValid = false;
                return false;
            }
        });

        if (isValid) {
            $('#treatment-details').addClass('hidden');
            $('#patients-details').removeClass('hidden');
            updateBreadcrumb(2);
            scrollToSection('#patients-details');
        }
    });

    $('#back-button').click(function() {
        $('#patients-details').addClass('hidden');
        $('#treatment-details').removeClass('hidden');
        updateBreadcrumb(1);
        scrollToSection('#treatment-details');
    });

    $('#continue-button').click(function() {
        var isValid = true;
        var requiredFields = [
            'input[name="patient1-name"]',
            'select[name="patient1-gender"]',
            '#phone1'
        ];

        requiredFields.forEach(function(selector) {
            var element = $(selector);

            if (element.is(':invalid') || !element.val()) {
                isValid = false;
                return false;
            }
        });

        if (isValid) {
            var name = $('input[name="patient1-name"]').val();
            var gender = $('select[name="patient1-gender"]').val();
            var mobile_number = $('#phone1').val();

            registerUser(name, gender, mobile_number).done(function() {
                $('#patients-details').addClass('hidden');
                $('#package-selection').removeClass('hidden');
                updateBreadcrumb(3);
                scrollToSection('#package-selection');
            });
        }
    });

    $('#back-button-package').click(function() {
        $('#package-selection').addClass('hidden');

        if (userId) {
            $('#treatment-details').removeClass('hidden');
            updateBreadcrumb(1);
            scrollToSection('#treatment-details');
        } else {
            $('#patients-details').removeClass('hidden');
            updateBreadcrumb(2);
            scrollToSection('#patients-details');
        }
    });

    $(document).on("click", "#date", function () {
        var treatmentId = $('input[name="treatment"]:checked').val();

        if (!treatmentId) {
            alert("Please select a treatment first");
            return;
        }

        var therapistId = $("#therapist").val(); 

        if (!therapistId) {
            alert("Please select a therapist");
            return;
        }

        fetch(`https://app.healthagon.ae/Home/getTherapistAvailability?therapist=${therapistId}`)
            .then(res => res.json())
            .then(days => {
                const input = document.getElementById("date");

                input.addEventListener("input", function () {
                    const selected = new Date(this.value);
                    const jsDay = selected.getDay();
                    const phpDay = (jsDay === 0 ? 1 : jsDay + 1);

                    if (days.length > 0 && !days.includes(phpDay.toString())) {
                        this.value = "";
                        this.style.border = "2px solid red";
                        this.setCustomValidity("Therapist is not available on this day");
                        this.reportValidity();
                    } else {
                        this.style.border = "";
                        this.setCustomValidity("");
                    }
                });
            });
    });

    $('#proceed-to-payment').click(function() {
        if (!$('input[name="privacy-policy"]').is(':checked')) {
            alert('You must agree to the privacy policy before proceeding.');
            return;
        }

        if ($('#timeslot').val() === '' || $('#date').val() === '' || !$('input[name="treatment"]:checked').val() ||
            !$('input[name="package"]:checked').val() || !$('input[name="duration"]:checked').val() ||
            !$('input[name="therapistPreference"]:checked').val() || $('#therapist').val() === '') {
            alert('Please fill out all required fields.');
            return;
        }

        var start_time = $('#timeslot').val();
        var booking_date = $('#date').val();
        var type = 'clinic';
        var service = $('input[name="treatment"]:checked').val();
        var package = $('input[name="package"]:checked').val();
        var number_of_people = 'one';
        var duration = $('input[name="duration"]:checked').data('duration');
        var number_of_session = $('input[name="package"]:checked').data('nb-of-session');
        var gender = $('input[name="therapistPreference"]:checked').val();
        var therapist = $('#therapist').val();
        var discountCode = 'uplift95';
        var userId = localStorage.getItem('userId');

        dataLayer.push({
            ecommerce: null
        });

        dataLayer.push({
            event: "begin_checkout",
            ecommerce: {
                currency: "AED",
                value: 450.50,
                items: [{
                    item_id: service,
                    item_name: $('input[name="treatment"]:checked').next('p').text(),
                    affiliation: "Healthagon",
                    coupon: discountCode,
                    currency: "AED",
                    discount: 10.00,
                    index: 1,
                    treatment_type: "physiotherapy",
                    people: "1",
                    therapist_preference: gender,
                    therapist: therapist,
                    date: booking_date,
                    slot: package
                }]
            }
        });

        var paymentData = {
            start_time: start_time,
            booking_date: booking_date,
            type: type,
            service: service,
            package: package,
            number_of_people: number_of_people,
            duration: duration,
            number_of_session: number_of_session,
            gender: gender,
            therapist: therapist,
            userid: userId,
            discountCode: discountCode
        };

        var queryString = $.param(paymentData);
        var requestUrl = 'https://app.healthagon.ae/Home/choosePayment?' + queryString;

        console.log('Request URL:', requestUrl);

        $.ajax({
            url: requestUrl,
            method: 'GET',
            async: false,
            success: function(response) {
                try {
                    var parsedResponse = JSON.parse(response);
                    $('#loading-indicator').show();

                    if (parsedResponse && parsedResponse.startsWith("https")) {
                        window.location.href = parsedResponse.replace(/\\\//g, '/');
                    } else {
                        alert('Unexpected response format.');
                    }
                } catch (e) {
                    console.error('Error parsing response:', e);
                    alert('Unexpected response format.');
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.error('Payment error:', textStatus, errorThrown);
                alert('There was an error processing the payment.');
            },
            complete: function() {
                $('#loading-indicator').hide();
            }
        });
    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        if (this.header) {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        if (!this.header) return;

        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        if (!this.header) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky || !this.header) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky || !this.header) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky || !this.header) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        if (!this.header) return;
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => disclosure.close());
      }

      closeSearchModal() {
        if (!this.header) return;
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        if (this.searchModal) {
          this.searchModal.close(false);
        }
      }
    }

    if (!customElements.get('sticky-header')) {
      customElements.define('sticky-header', StickyHeader);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insurance-providers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.insurance-providers__tab');
    const contents = document.querySelectorAll('.insurance-providers__details');
    const searchInput = document.querySelector('.insurance-providers__search-input');
    const searchButton = document.querySelector('.insurance-providers__search-button');
    const searchResultsContainer = document.querySelector('.insurance-providers__search-results');

    function showContent(index) {
      tabs.forEach((tab, idx) => {
        if (idx === index) {
          tab.classList.add('active');
          contents[idx].classList.add('active');
        } else {
          tab.classList.remove('active');
          contents[idx].classList.remove('active');
        }
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        showContent(index);
      });
    });

    // Activate the first tab and content by default
    if (tabs.length > 0) {
      showContent(0);
    }

      // Search functionality
      searchButton.addEventListener('click', () => {
        const searchTerm = searchInput.value.toLowerCase();
      
        // Minimum search term length
        if (searchTerm.length < 2) {
          searchResultsContainer.innerHTML = 'Please enter at least 2 characters.';
          return;
        }
      
        let results = [];
      
        tabs.forEach((tab, index) => {
          const contentText = contents[index].textContent.toLowerCase();
          if (contentText.includes(searchTerm) || tab.textContent.toLowerCase().includes(searchTerm)) {
            results.push({ tab: tab.textContent, index: index });
          }
        });
      
        if (results.length > 0) {
          showContent(results[0].index);
          searchResultsContainer.innerHTML = `Found ${results.length} result(s) in the following tabs: ${results.map(result => result.tab).join(', ')}`;
      
          // Highlight matches
          results.forEach(result => {
            const content = contents[result.index];
            const highlightedText = content.innerHTML.replace(new RegExp(searchTerm, 'gi'), match => `<mark>${match}</mark>`);
            content.innerHTML = highlightedText;
          });
        } else {
          searchResultsContainer.innerHTML = 'No results found.';
        }
      });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memberships"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.swiper', {
    slidesPerView: 1.5,
    spaceBetween: 5,
    navigation: {
      nextEl: '.arrow-right',
      prevEl: '.arrow-left',
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 5,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 5,
      },
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing-section-bg"] && !Shopify.designMode) return;
  try {
    
  const tabButtons = document.querySelectorAll('.tab-link');
  const tabContents = document.querySelectorAll('.tab-content');

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabId = button.getAttribute('data-tab');

      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));

      button.classList.add('active');

      const activeTab = document.getElementById(tabId);
      if (activeTab) {
        activeTab.classList.add('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
